import { Injectable } from '@angular/core';
import { ApiRequestService } from '../../shared/api-request.service';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../models/api-response.model';
import { CodeModel } from '../../models/code.model';

type ResponseEntity = ApiResponseModel<CodeModel>;
type ResponseEntities = ApiResponseModel<CodeModel[]>;

@Injectable({
  providedIn: 'root'
})
export class CodesService {
  constructor(private api: ApiRequestService) {}

  public post(code: CodeModel): Observable<ResponseEntity> {
    return this.api.makeRequestObservable('post', 'v1/codes', code);
  }

  public delete(id: number): Observable<ResponseEntity> {
    return this.api.makeRequestObservable('delete', `v1/codes/${id}`);
  }

  public find(id: number): Observable<ApiResponseModel<CodeModel>> {
    return this.api.makeRequestObservable('get', `v1/codes/${id}`);
  }

  public get(): Observable<ResponseEntities> {
    return this.api.makeRequestObservable('get', 'v1/codes');
  }

  public put(code: CodeModel): Observable<ResponseEntity> {
    return this.api.makeRequestObservable('put', `v1/codes/${code.id}`, code);
  }

  public unlink(id: number): Observable<null> {
    return this.api.makeRequestObservable('patch', `v1/codes/${id}/unlink`, {});
  }

  public addMany(
    _name: string,
    _number: number,
    _feature: string = 'Access Control'
  ): Observable<ApiResponseModel<number[]>> {
    return this.api.makeRequestObservable('post', 'v1/codes/many', {
      name: _name,
      number: _number,
      feature: _feature
    });
  }

  public deleteMany(ids: number[]): Observable<ApiResponseModel<null>> {
    return this.api.makeRequestObservable('post', 'v1/codes/delete-many', {
      code_ids: ids
    });
  }

  public unlinkMany(ids: number[]): Observable<ApiResponseModel<null>> {
    return this.api.makeRequestObservable('patch', 'v1/codes/unlink-many', {
      code_ids: ids
    });
  }
}
